import React from "react";
import { Modal as AntModal } from "antd";
import { cx } from "../../utils/classNames";

export function Modal({
  open,
  title,
  onClose,
  children,
  actions,
  className,
  width,
  centered = true,
  ...rest
}) {
  return (
    <AntModal
      open={open}
      title={title}
      onCancel={onClose}
      footer={actions}
      centered={centered}
      destroyOnClose
      className={cx("app-modal", className)}
      width={width}
      {...rest}
    >
      {children}
    </AntModal>
  );
}

export default Modal;
